<template>
  <b-modal id="blackListModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
    <UploadBox @fileBoxData="uploadedFiles($event)" :filesLength="1" />
    <div class="d-flex mt-2 flex-row-reverse">
      <Button text="ثبت" btnClass="approve" @click.native="submit" :loading="btnLoading" />
      <Button text="انصراف" btnClass="cancel" @click.native="$bvModal.hide('blackListModal')" />
    </div>
  </b-modal>
</template>

<script>
import UploadBox from '@/components/common/form/formModules/UploadBox.vue'
import Button from '@/components/common/Button.vue'
import notificationsDataProvider from '../../../services/notifications'
export default {
  components: {
    UploadBox,
    Button,
  },
  data() {
    return {
      files: [],
      btnLoading: false,
    }
  },
  methods: {
    submit() {
      this.btnLoading = true
      if (this.files.length > 0) {
        notificationsDataProvider
          .setBlackList(this.files)
          .then((res) => {
            this.btnLoading = false
            this.$bvModal.hide('blackListModal')
          })
          .catch((err) => {
            console.log(err)
            this.btnLoading = false
            this.$bvModal.hide('blackListModal')
          })
      } else {
        this.btnLoading = false
      }
    },
    uploadedFiles($event) {
      this.files = $event.map((e) => e.url)
    },
  },
  mounted() {
    this.$bvModal.show('blackListModal')
  },
  beforeDestroy() {
    this.$bvModal.hide('blackListModal')
  },
}
</script>

<style scoped lang="sass">
@import 'setting'
</style>
